export const KnownCustomProtocolsToTheirAssociatedDomains: {[key: string]: string} = {
  "bitwarden:": "vault.bitwarden.com"
};
